import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as Settings } from "../../../assets/settings.svg";
import { ReactComponent as ProjectIcon } from "../../../assets/projects-icon.svg";
import { ReactComponent as SetupIcon } from "../../../assets/setup-icon.svg";
import { ReactComponent as IMS } from "../../../assets/ims.svg";
import UseGetUserRole from "../../../components/useGetUserRole";

const useSidebar = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [data, setData] = useState();
  const [isSuperAdmin] = UseGetUserRole();
  const [showSettings, setShowSettings] = useState(true);

  useEffect(() => {
    setData(user);
    // if (user?.permissions !== undefined && user?.permissions !== null) {
    //   let settingsPerKeys = ["ims", "project_setup"];
    //   Object.entries(user?.permissions).map((el) => {
    //     let [key, perObj] = el;
    //     if (!settingsPerKeys.includes(key)) {
    //       if (perObj?.view) {
    //         setShowSettings(true);
    //       }
    //     }
    //   });
    // }
  }, [user]);

  const hanldeRoleLength = (role) =>
    role.length > 20 ? `${role.substring(0, 18) + " ..."}` : role;

  const hanldeNameLength = (role) =>
    role.length > 15 ? role.substring(0, 15) : role;

  const menuItemsData = [
    {
      key: "1",
      src: data?.profile_picture?.length > 1 ? data?.profile_picture : null,
      SvgImg: false,
      alt: "",
      name: hanldeNameLength(data?.first_name + " " + data?.surname || ""),
      role: hanldeRoleLength(data?.job_title || ""),
      link: "/profile",
      hasSubItems: false,
      permission: true,
      hasPermission: true,
    },
    {
      key: "2",
      SvgImg: IMS,
      alt: "IMS logo",
      name: "IMS",
      link: "/ims",
      hasSubItems: true,
      hasPermission: user?.permissions?.ims?.view,
      subItems: [
        {
          key: "document-control",
          SvgImg: Settings,
          alt: "IMS",
          name: "Document Control",
          link: "/ims/document-control",
          hasSubItems: false,
          hasPermission: true,
        },
      ],
    },
    {
      key: "3",
      SvgImg: ProjectIcon,
      alt: "Project Icon",
      name: "Projects",
      // subItems: "Select Project",
      link: "/projects",
      hasSubItems: true,
      hasPermission: true,
      subItems: [
        {
          key: "project-control",
          SvgImg: Settings,
          alt: "project-Control",
          name: "project-Control",
          link: "/project/document-control",
          hasSubItems: false,
          hasPermission: true,
        },
      ],
    },
    {
      key: "4",
      SvgImg: SetupIcon,
      alt: "Project Icon",
      name: "Projects Setup",
      link: "/projects-setup",
      hasSubItems: false,
      hasPermission: user?.permissions?.project_setup?.view,
    },
    {
      key: "6",
      SvgImg: Settings,
      alt: "settings",
      name: "Settings",
      link: "/settings",
      hasSubItems: true,
      // permission: ["super_admin", "admin"],
      hasPermission: showSettings,
      subItems: [
        {
          key: "users-manager",
          SvgImg: Settings,
          alt: "Users Manager",
          name: "Users Manager",
          link: "/settings/users-manager",
          hasSubItems: false,
          hasPermission: user?.permissions?.user_manager?.view,
        },
        {
          key: "document-types-manager",
          SvgImg: Settings,
          alt: "Document Types Manager",
          name: "Document Types Manager",
          link: "/settings/document-types-manager",
          hasSubItems: false,
          hasPermission: user?.permissions?.doc_types_manager?.view,
        },
        {
          key: "default-document-fields",
          SvgImg: Settings,
          alt: "Default Document Fields",
          name: "Default Document Fields",
          link: "/settings/default-document-fields",
          hasSubItems: false,
          hasPermission: user?.permissions?.default_doc_fields?.view,
        },
        {
          key: "document-statuses",
          SvgImg: Settings,
          alt: "Document Statuses",
          name: "Document Statuses",
          link: "/settings/document-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.document_statuses?.view,
        },
        {
          key: "project-statuses",
          SvgImg: Settings,
          alt: "Project Statuses",
          name: "Project Statuses",
          link: "/settings/project-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.project_statuses?.view,
        },
        {
          key: "revision-statuses",
          SvgImg: Settings,
          alt: "Revision Statuses",
          name: "Revision Statuses",
          link: "/settings/revision-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.revision_statuses?.view,
        },
        {
          key: "departments",
          SvgImg: Settings,
          alt: "Departments",
          name: "Departments",
          link: "/settings/departments",
          hasSubItems: false,
          hasPermission: user?.permissions?.departments?.view,
        },
      ],
    },
  ];

  return [menuItemsData];
};

export default useSidebar;
